// en, de, fr, pt
export default {
  fr: {
    commons: {
      saveUpdate: 'Sauvegarder les modifications',
      cancelAndGoBack: 'Annuler et revenir en arrière',
      confirmPopoverMessage: 'Êtes-vous sûr(e) ?',
      confirmButtonText: 'OK',
      cancelButtonText: 'Annuler',
      defaultErrorMessage: 'Une erreur est survenue',
      fieldRequiredMessage: 'mot de passe vide',
    },
    shopAuth: {
      title: 'Connexion magasin',
      emailLabel: 'Adresse email du magasin',
      submitButtonText: 'Se connecter',
      validEmailRequiredMessage: 'Un email valide est requis',
      successMessage: 'Un lien de connexion vous a été transmis par email',
    },
    authPage: {
      title: 'Connexion',
      emailLabel: 'mail',
      submitButtonText: 's\'authentifier',
      checkEmail: 'lien disponible en email',
    },
    shopMLPage: {
      shopMLVerificationSuccess: 'magasin authentifié!',
    },
    loginPage: {
      title: 'Connectez-vous',
      usernameLabel: 'Nom utilisateur',
      passwordLabel: 'Mot de passe',
      submitButtonText: 'Se connecter',
      successMessage: 'Bienvenue',
    },
    mainNav: {
      logoutMenuItem: 'Déconnexion',
      helloWorldMenuItem: 'Catalogue',
      cartMenuItem: 'Panier',
      historyMenuItem: 'historique',
    },
    // components
    home: {
      title: 'MARKETPLACE',
      order: 'trier les produits',
      nameOrder: 'par nom',
      unitOrder: 'par unité',
      marieBlachereLink: 'Marie Blachère ©',
      placeholder: 'rechercher un produit',
    },
    cart: {
      cart: 'Panier',
      emptyCart: 'vider le panier',
      validateCart: 'valider le panier',
      deleteProduct: 'Voulez-vous vraiment vider votre panier?',
      abort: 'Annuler',
      confirm: 'Confirmer',
      send: 'mail envoyé',
    },
    history: {
      title: 'Historique',
      noHistoryFound: 'Aucun historique de commande disponible',
      cardTitle: 'Produits commandés par',
    },
  },
};
